import React from 'react';
import BulletedRuleDescription from 'components/triggers/BulletedRuleDescription';

export default class TriggerRuleInfoComponent extends React.Component {
  render() {
    const {rule} = this.props;

    return (
      <div className="trigger-rule">
        <div className="trigger-rule-info">
          <BulletedRuleDescription
            text={rule.name}
            timing={rule.trendDescription}
            actionNames={rule.actionNames}
          />
        </div>
      </div>
    );
  }
}
